import Action from './action';
import State from './state';
import Workflow from './workflow';

export default class WorkflowAffect {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {any} [affect]
	 */
	constructor($injector, affect = undefined) {
		this.$injector = $injector;
		/** @type {import('angular').translate.ITranslateService} */
		this.$translate = $injector.get('$translate');
		this.action = affect?.action;
		if (affect.wfaction) {
			this.action = new Action($injector, affect.wfaction.kid);
			this.action.isa.objid = affect.wfaction.isa;
			this.action.lang.kid = affect.wfaction.lang.kid;
			this.action.lang.isa = affect.wfaction.lang.isa;
			this.action.setName(affect.wfaction.name);
			this.action.type_kid = affect.wfaction.type_kid;
		}
		this.allocatorTo = affect?.allocatorTo ?? affect?.allocator_to;
		this.comment = affect?.comment ?? affect?.wfcomment;
		this.date = affect?.date?.name ? new Date(affect.date.name) : undefined;
		this.document = affect?.document;
		this.kid = affect?.kid;
		this.observations = affect?.observations ?? affect?.wfobservations.map((/** @type {any} */ o) => ({
			...o,
			file: o.files?.length > 0 ? o.files[0] : null,
		}));
		this.profilFrom = affect?.profilFrom ?? affect?.profil_from;
		this.state = affect?.state
			?? (affect?.wfstate ? Object.assign(new State($injector, affect.wfstate.kid), affect.wfstate) : undefined);
		this.status = affect?.status ?? affect?.wfstatus;
		this.workflow = affect?.workflow
			?? (affect?.wf ? Object.assign(new Workflow($injector, affect.wf.kid), affect.wf) : undefined);
	}

	/**
	 * @returns {string}
	 */
	getJobDescription(){
		let status = this.status.kid.split(';')[1];
		const $sce = this.$injector.get('$sce');

		if (this.action.kid === 'K_NODE;WFAC_INITIAL') {
			status = 'WFS_CREATION';
		}

		const description = this.$translate.instant(`workflow.go-state.${status}`, {
			...this,
			allocators: this.allocatorTo.map((/** @type {any} */ a) => a.name).join(', '),
			wf: this.workflow,
			wfstate: this.state,
		});

		return $sce.trustAsHtml(description);
	}
}
